import { createContext } from 'react';

const ToastCtx = createContext<any>({
  toasts: [],
  setToast: () => null,
});

export default ToastCtx;
